<template>
  <NewsListPageContent
    :sort-type="NavigationSortType.All"
    :category="category"
    :category-sorts="sortsInCategory"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useNavigation } from '~/stores/navigation'
import { NavigationSortType } from '~/models/navigation'

const route = useRoute()
const { getCategorySortItems, categoriesSlugMap, getCategoryMeta } =
  useNavigation()
const { t } = useI18n()

const category = categoriesSlugMap[route.params.category as string]

if (!category) {
  throw useCreateScreenError({
    message: `category ${route.params.category} is not found on category index`,
  })
}

const sortsInCategory = getCategorySortItems('news', category.slug, [
  NavigationSortType.Premium,
  NavigationSortType.All,
])

const categoryName = getFieldLocale(category.title)
const { metaTitle, metaKeywords, metaDescription } = getCategoryMeta(category)
const title = `${t('head_meta.default_title')}. ${t('menu.feed')}. ${
  metaTitle || categoryName
} - hot`

useHeadMeta({
  title,
  description: metaDescription || title,
  keywords: `${metaKeywords || categoryName}, WN, feed, WN Hub, game, events`,
  image: category?.background.length ? category?.background[0].url : '',
})
</script>
